import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DataTable from "react-data-table-component";
import Svg from "../../component/common/Svg";
import SurveyListHeader from '../../component/common/layout/SurveyListHeader';
import SurveyListSidebar from '../../component/common/layout/SurveyListSidebar';
import SearchInput from "../../core/Inputs/SearchInput";
import { getActivityLogs } from '../../store/actions/activityLogsActions';
import style from "../style.module.css"; // Same style as DataTablesSurveyList
import Card from "../../core/Card";
import moment from "moment";
export default function ActivityLogs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activityLogs, totalRecords, isLoading } = useSelector((state) => state.activityLogs);
  const { t } = useTranslation();

  // State for pagination and search
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [filters, setFilters] = useState({ search: "" });

  

  useEffect(() => {
    const payload = {
      startingLimit: (page - 1) * perPage,
      resultsPerPage: perPage,
      search: filters.search
    };
    dispatch(getActivityLogs(payload));
  }, [dispatch, page, perPage, filters]);

  // Define columns for DataTable
  const columns = [
    {
      name: t('activityLog.message'),
      selector: (row) => row.content,
      cell: (row) => (
        <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", maxWidth: "500px" }}>
          {row.content}
        </div>
      ),
      grow: 2,
    },
    {
      name: t('activityLog.action'),
     cell: row => (
    <div className="">
      {row.action}
    </div>
  ),
    },
    {
      name: t('activityLog.added_by'),
      selector: (row) => row.user_name,
      cell: (row) => <div className="">{row.user_name}</div>
    },
    //   {
    //   name: t('activityLog.dateTime'),
    //   selector: row => row.date ?  moment(row.date, "DD-MM-YYYY | hh:mm A").format(
    //                 "YYYY/MM/DD"
    //               ) : '',
       
    // },
    {
  name: t('activityLog.date_time'),
   cell: row => (
      <div className="">
        {row.date
          ? moment.utc(row.date)        
                  .local()            
                  .format('DD‑MM‑YYYY | hh:mm A') 
          : ''}
      </div>
    ),
}
  ];

  // Pagination handlers
  const handlePageChange = (p) => setPage(p);
  const handlePerRowsChange = (newPerPage, p) => {
    setPerPage(newPerPage);
    setPage(p);
  };

   return (
     <div className="d-flex flex-column main-outer-wrapper">
            <SurveyListHeader />
    <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
      <div id="viewport" className="d-flex">
        {/* Sidebar identical to survey list pages */}
        <SurveyListSidebar />

        <div id="content" className="flex-grow-1 dashboard-page-outer d-flex flex-column overflow-full-height">
          <div className="dashboard-page-wrap">
            {/* Page heading / breadcrumb block (mirrors Survey list) */}
            <div className="page-heading d-md-flex align-items-center justify-content-between">
              <div className="head-lef">
                <h1>{t('activityLog.title')}</h1>
              </div>
            </div>

            {/* Search‑bar & filter row */}
            <div className="table-wrapper-view">
            

              {/* DataTable in the same wrapper classes used by Survey list */}
              <div className="tablePage bg-white">
                <div className="table-wrap custom-data-table">
                  <DataTable
                    columns={columns}
                    data={activityLogs}
                    pagination
                      paginationPerPage={30}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}
